<style scoped>
  .btn-text:active {
    color: #2b85e4 !important;
  }
  .radio-item-ui {
    display: block;
    padding: 15px;
    text-align: left;
    cursor: pointer;
  }
  .radio-item-ui p {
    padding-left: 21px;
    color: #aaa;
  }
</style>

<template>
  <app-layout style="margin: 16px">
    <Modal
        title="Note"
        v-model="showWarningAlert"
        :footer-hide="true"
        @on-cancel="showWarningAlert = false"
        class-name="vertical-center-modal">
        <p>Anonymous users are free to comment or post, but since you are completely anonymous your comments or posts will be delayed until a moderator clears it.</p>
        <p align="right" style="padding-top:20px">
          <Button type="primary" @click="onSetRegistrationMethod(true)">Proceed</Button></p>
    </Modal>
    
    <p style="text-align:center;font-size: 3vh;line-height: 1.5;margin-bottom:16px" v-if="false">
      <Row type="flex" :gutter="20">
        <i-col :span="24" style="text-align:left">
          <p class="title-question-ui" align="center">How do you want to register?</h4>
          <div>
            <RadioGroup v-model="selection">
              <Radio label="mobile" class="radio-item-ui">
                <Icon type="logo-android"></Icon>
                <span class="title-question-ui subs">Mobile</span>
                <p style="font-size:14px">You will get an activation code.</p>
              </Radio>
              <Radio label="email" class="radio-item-ui">
                <Icon type="logo-apple"></Icon>
                <span class="title-question-ui subs">Email</span>
                <p style="font-size:14px">You must confirm your email address.</p>
              </Radio>
              <Radio label="anonymous" :disabled="true" class="radio-item-ui">
                <Icon type="logo-windows"></Icon>
                <span class="title-question-ui subs">Anonymous</span>
                <p style="font-size:14px">You are completely anonymous,<br />but all comments and post will be moderated</p>
              </Radio>
            </RadioGroup>
          </div>
        </i-col>
      </Row>
    </p>
    <div display="flex" style="padding:10px" v-if="false">
      <a @click="onSetRegistrationMethod()" style="margin-left:5px">
        <Button type="primary" style="float:right">Next</Button>
      </a>
      <Button @click="goBack()" type="text" class="btn-text" style="float:right;margin-right:10px;padding:6px 15px;color:#495060">
        Go Back
      </Button>
    </div>
  </app-layout>
</template>

<script>
  export default {
    name: "StepThreeMobileComponent",
    data() {
      return {
        selection: "mobile",
        showWarningAlert: false
      };
    },
    created() {
      this.$router.push(`/${this.$route.params.brandSlug}/verify`)
    },
    mounted() {
      this.selection = this.regType
    },
    watch: {
      selection(v) {
        if (v)
          this.regType = v
      }
    },
    computed: {
      regType: {
        get() {
          return this.$route.query.type ? this.$route.query.type : "email"
        },
        set(v) {
          this.$router.replace({
            path: '/step3',
            query: {
              type: v
            }
          })
        }
      }
    },
    methods: {
      onSetRegistrationMethod(isConfirmed) {
        if( this.selection == 'mobile') 
          this.$router.push('/verify?step=true');
        else if ( this.selection == 'anonymous' )
          if(!isConfirmed) {
            this.showWarningAlert = true;
          } else {
            this.$router.push('/login?type=signup&step=true&method='+this.selection);
            this.showWarningAlert = false;
          }
        else 
          this.$router.push('/login?type=signup&step=true&method='+this.selection);
      },
      goBack() {
        window.history.back();
      },
    }
  };
</script>
